import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { AnulacionService } from '../../solicitudes/anulacion/anulacion.service';
import { SolicitudService } from '../../solicitudes/datosbasicos/datosbasicos.service';
import { EnumIdsTcEstadoSolicitud, EnumCodigosTwTcAcciones, EnumIdsTwTcTipoClonacion } from '../types/enum';
import { TAnulacionSolicitudViewModel, SolicitudAnulacionViewModel } from './anulacion.types';

@Component({
    selector: 'app-anulacion-edit',
    templateUrl: './anulacion-edit.component.html',
})
export class AnulacionEditComponent extends ComponentBase implements OnInit {
    nombreUsuario = '';
    solicitudAnulacion: SolicitudAnulacionViewModel;
    anulacion: TAnulacionSolicitudViewModel;
    idSolicitud = 0;
    tituloTipoSolicitud: string;
    habilitarGuardar = true;
    esNuevaAnulacion = false;
    visibilitySpinner = false;
    esClonada = false;
    IdTipoSolicitud: number;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private solicitudService: SolicitudService,
        private navMenuService: NavMenuService,
        private anulacionService: AnulacionService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudAnulacion = new SolicitudAnulacionViewModel();
    }

    ngOnInit() {
        this.idSolicitud = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitud);

        this.createForm();

        if (this.idSolicitud) {
            this.loading = true;

            this.anulacionService.getSolicitudAnulacion(this.idSolicitud).subscribe(result => {
                this.solicitudAnulacion = result;

                this.IdTipoSolicitud = this.solicitudAnulacion.IdTipoSolicitud;
                this.tituloTipoSolicitud = this.solicitudAnulacion.IdTipoSolicitudDescripcion;

                this.esClonada =
                    this.solicitudAnulacion.TwSolicitudJerarquia != null &&
                    this.solicitudAnulacion.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;
                //SI ES RE-IMPORTACION
                if (this.solicitudAnulacion.EsReImportacion) {
                    this.tituloTipoSolicitud += ' - Re-Importación';
                }
                //SI ES PREVIA
                if (this.solicitudAnulacion.EsPrevia) {
                    if (
                        this.solicitudAnulacion.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                        this.solicitudAnulacion.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitud += ' - Previa';
                    }
                }

                this.esNuevaAnulacion = this.solicitudAnulacion.TAnulacion == null ? true : false;

                //correo: lo de anular a una solicitud enviada sin que haya sido editada por el inspector lo vamos a tratar como que puede anular directamente en estado nueva
                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.ANULACION_SOLICITUD,
                    this.solicitudAnulacion.IdEstadoSolicitud,
                ).Visible;

                //TODO: jlht Temporal hasta que TRACES arregle su bug de no poder anular cuando la solicitud tiene detalles del rechazo
                this.habilitarGuardar = this.habilitarGuardar && this.solicitudAnulacion.TwInspeccionRechazo === null;

                if (!this.esNuevaAnulacion) {
                    this.updateForm();
                } else {
                    this.form.patchValue({
                        IdUsuario: this.loggedInUser!.Id,
                        CodigoTraces: this.solicitudAnulacion.CodigoTraces,
                        //NombreInspector: this.loggedInUser!.Nombre + ' ' + this.loggedInUser!.Apellidos,
                    });

                    if (this.habilitarGuardar) {
                        this.form.controls['Observaciones'].enable();
                    }
                }
            });

            this.loading = false;
        }
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            IdUsuario: '',
            NombreUsuario: [{ value: '', disabled: true }],
            Observaciones: [{ value: '', disabled: true }, Validators.required],
            Fecha: [{ value: '', disabled: true }, Validators.required],
            CodigoTraces: [{ value: '', disabled: true }],
            IdAnulacion: [{ value: '', disabled: true }, Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            IdAnulacion: this.solicitudAnulacion.TAnulacion.Id,
            NombreUsuario: this.solicitudAnulacion.TAnulacion.NombreUsuario,
            IdUsuario: this.solicitudAnulacion.TAnulacion.IdUsuario,
            Observaciones: this.solicitudAnulacion.TAnulacion.Observaciones,
            CodigoTraces: this.solicitudAnulacion.CodigoTraces,
            Fecha: new Date(this.solicitudAnulacion.TAnulacion.Fecha),
        });
    }

    onCleanObservacion() {
        this.form.patchValue({ Observaciones: '' });
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/datosbasicos', this.navMenuService.currentSolicitudImportacion.Id]);
    }

    enviarAnulacion() {
        //Nueva confirmacion de estado, para impedir anulaciones si ya las ha aceptado el inspector
        this.anulacionService.getSolicitudAnulacion(this.idSolicitud).subscribe(result => {
            if (
                this.isSolicitante &&
                result.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_NUEVA &&
                result.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
            ) {
                this.addInfoMessage('El estado de la solicitud ha cambiado, por favor, vaya al apartado INSPECCIONES');
            } else {
                this.confirmationService.confirm({
                    message: '¿Está seguro de anular la solicitud actual?.\nTenga en cuenta que no podrá deshacer la operación.',
                    accept: () => {
                        this.onSubmit();
                    },
                });
            }
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        //let anulacion = new TAnulacionSolicitudViewModel();

        ////así­ viajan todos los values, da igual si están disable o no los campos
        //anulacion = this.form.getRawValue();
        //anulacion.IdSolicitud = this.esNuevaAnulacion ? this.idSolicitud : this.solicitudAnulacion.Id;
        ////aunque en servidor se le asigne la fecha del día, al ser campo obligatorio en el modelo hay que darle valor para que no falle
        //anulacion.Fecha = this.esNuevaAnulacion ? new Date() : this.solicitudAnulacion.TAnulacion.Fecha;
        //anulacion.CodigoTraces = this.solicitudAnulacion.CodigoTraces;

        let anulacion = this.esNuevaAnulacion ? new TAnulacionSolicitudViewModel() : this.solicitudAnulacion.TAnulacion;

        //así­ viajan todos los values, da igual si están disable o no los campos
        anulacion = this.form.getRawValue();
        anulacion.IdSolicitud = this.esNuevaAnulacion ? this.idSolicitud : this.solicitudAnulacion.Id;
        //aunque en servidor se le asigne la fecha del día, al ser campo obligatorio en el modelo hay que darle valor para que no falle
        anulacion.Fecha = this.esNuevaAnulacion ? new Date() : this.solicitudAnulacion.TAnulacion.Fecha;

        this.solicitudAnulacion.TAnulacion = anulacion;

        if (this.esNuevaAnulacion) {
            this.anulacionService.createAnulacion(this.solicitudAnulacion).subscribe({
                next: () => {
                    this.addSuccessMessage('Anulación creada correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }
}
